import productMonitoring from "../productMonitoring";

export const logEventPromptUserToRateApp = async (): Promise<void> => {
  productMonitoring.logEvent(`prompt:rate-app`);
}
